/** @format */

export default function (state = "2.1", action) {
  return state;
}
